"use strict";
var aCallable = require("../internals/a-callable");
var anObject = require("../internals/an-object");
var call = require("../internals/function-call");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var getIteratorDirect = require("../internals/get-iterator-direct");
var INVALID_SIZE = "Invalid size";
var $RangeError = RangeError;
var $TypeError = TypeError;
var max = Math.max;
var SetRecord = function(set, intSize) {
  this.set = set;
  this.size = max(intSize, 0);
  this.has = aCallable(set.has);
  this.keys = aCallable(set.keys);
};
SetRecord.prototype = {
  getIterator: function() {
    return getIteratorDirect(anObject(call(this.keys, this.set)));
  },
  includes: function(it) {
    return call(this.has, this.set, it);
  }
};
module.exports = function(obj) {
  anObject(obj);
  var numSize = +obj.size;
  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
  var intSize = toIntegerOrInfinity(numSize);
  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};
